var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoauthorStories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D3ECCCC-E385-4E69-B156-D77B7D08EC05@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,22.5 C45,34.9262069 34.9262069,45 22.5,45 C10.0737931,45 0,34.9262069 0,22.5 C0,10.0737931 10.0737931,0 22.5,0 C34.9262069,0 45,10.0737931 45,22.5 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,25 C50,38.8068966 38.8068966,50 25,50 C11.1931034,50 0,38.8068966 0,25 C0,11.1931034 11.1931034,0 25,0 C38.8068966,0 50,11.1931034 50,25 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,20 C40,31.0455172 31.0455172,40 20,40 C8.95448276,40 0,31.0455172 0,20 C0,8.95448276 8.95448276,0 20,0 C31.0455172,0 40,8.95448276 40,20 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01X---Onboarding",
    transform: "translate(-62.000000, -1430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(19.000000, 1430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-5",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 124,
    cy: 124,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "coauthor-stories",
    transform: "translate(23.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-2562",
    fill: "#25D086",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34594689,39.365764 C9.87393632,37.9495076 11.637931,37.2413793 11.637931,37.2413793 C11.637931,37.2413793 12.6724138,36.4655172 14.7413793,34.9137931 L12.4137931,29.4827586 L10.862069,29.25 L9.31034483,25.6034483 L10.5436631,21.375 C11.2731751,17.9889313 11.637931,16.2958969 11.637931,16.2958969 C11.637931,16.2958969 12.1551724,15.0018623 13.1896552,12.4137931 L16.728484,9.08077406 L21.1199005,7.75862069 L24.6688061,7.75862069 L29.0794191,9.08077406 L31.8103448,11.4666186 L33.5049626,13.1903379 L34.787773,13.9853147 L35.6896552,15.75 L35.6896552,17.0689655 L32.5862069,17.0689655 L34.137931,21.375 L35.6896552,23.5621924 L34.787773,27.9310345 L33.362069,29.4827586 L32.5862069,30.018007 L30.2586207,34.9137931 L33.5049626,37.2413793 L38.0172414,39.365764 L33.362069,44.2681717 L17.457035,46.594294 C12.8481204,44.4623707 10.5436631,43.3964091 10.5436631,43.3964091 C10.5436631,43.3964091 9.14442436,42.0528608 6.34594689,39.365764 Z",
    id: "Path-8",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98275862,38.7931034 C7.2962069,38.6518966 8.98137931,38.132069 9.31034483,38.0172414 L11.637931,37.2413793 C12.3284483,37.0008621 13.4115517,36.1660345 13.9655172,35.6896552 L14.7413793,34.9137931",
    id: "Stroke-2557",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5172414,
    y1: 23.2758621,
    x2: 10.862069,
    y2: 21.7241379,
    id: "Stroke-2558",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6896552,17.0689655 C35.6896552,17.0689655 27.6315517,15.5172414 22.5,15.5172414 C17.3653448,15.5172414 10.862069,17.0689655 10.862069,17.0689655 C10.862069,17.0689655 19.4027586,12.4137931 28.7068966,12.4137931 C37.8589655,12.4137931 35.6896552,17.0689655 35.6896552,17.0689655 Z",
    id: "Stroke-2559",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5862069,12.4137931 C31.0360345,9.88758621 27.0791379,7.75862069 22.5,7.75862069 C14.8018966,7.75862069 11.565,13.742069 10.862069,17.0689655",
    id: "Stroke-2560",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0172414,38.7931034 C37.7037931,38.6518966 36.0186207,38.132069 35.6896552,38.0172414 L33.362069,37.2413793 C32.6715517,37.0008621 31.5884483,36.1660345 31.0344828,35.6896552 L30.2586207,34.9137931",
    id: "Stroke-2561",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4137931,17.0689655 C11.637931,17.8448276 10.862069,21.7241379 10.862069,21.7241379 C9.79137931,21.7241379 9.31034483,23.4605172 9.31034483,25.6034483 C9.31034483,27.7463793 10.5672414,29.4827586 11.637931,29.4827586 L12.4137931,29.4827586 C13.7405172,33.3884483 16.8517241,38.9777586 20.1724138,39.9584483 C20.3182759,40.005 20.4656897,40.05 20.6146552,40.0872414 C20.817931,40.1353448 21.0212069,40.1818966 21.2291379,40.2160345 C21.672931,40.292069 22.0406897,40.3448276 22.5,40.3448276 C22.9593103,40.3448276 23.4884483,40.292069 23.9322414,40.2160345 C24.1401724,40.1818966 24.3434483,40.1353448 24.5467241,40.0872414 C24.6956897,40.05 24.8431034,40.005 24.9889655,39.9584483 C28.3096552,38.9777586 31.2594828,33.3884483 32.5862069,29.4827586 C32.85,29.7527586 33.0455172,29.4827586 33.362069,29.4827586 C34.4327586,29.4827586 35.6896552,27.7463793 35.6896552,25.6034483 C35.6896552,23.4605172 35.2086207,21.7241379 34.137931,21.7241379 C34.137931,21.7241379 33.362069,17.8448276 32.5862069,17.0689655",
    id: "Stroke-2563",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5862069,29.4827586 L32.5862069,27.9310345 C30.6698276,28.89 29.9312069,29.4827586 27.9310345,29.4827586 C25.9308621,29.4827586 24.6817241,27.9310345 22.5,27.9310345 C20.3182759,27.9310345 19.0691379,29.4827586 17.0689655,29.4827586 C15.0687931,29.4827586 14.3301724,28.935 12.4137931,27.9310345 L12.4137931,29.4827586",
    id: "Stroke-2564",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.7241379,
    y1: 31.0344828,
    x2: 23.2758621,
    y2: 31.0344828,
    id: "Stroke-2565",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.7241379,
    y1: 21.7241379,
    x2: 23.2758621,
    y2: 21.7241379,
    id: "Stroke-2566",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.4827586,
    y1: 23.2758621,
    x2: 34.137931,
    y2: 21.7241379,
    id: "Stroke-2567",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4827586,23.2758621 C29.4827586,24.9905172 28.0939655,26.3793103 26.3793103,26.3793103 C24.6646552,26.3793103 23.2758621,24.9905172 23.2758621,23.2758621 C23.2758621,21.5612069 24.6646552,20.1724138 26.3793103,20.1724138 C28.0939655,20.1724138 29.4827586,21.5612069 29.4827586,23.2758621 Z",
    id: "Stroke-2568",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7241379,23.2758621 C21.7241379,24.9905172 20.3353448,26.3793103 18.6206897,26.3793103 C16.9060345,26.3793103 15.5172414,24.9905172 15.5172414,23.2758621 C15.5172414,21.5612069 16.9060345,20.1724138 18.6206897,20.1724138 C20.3353448,20.1724138 21.7241379,21.5612069 21.7241379,23.2758621 Z",
    id: "Stroke-2569",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(158.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-2333",
    fill: "#25D086",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62068966,43.1034483 L15.491451,40.110147 L12.5,37.9310345 L8.62068966,37.0687931 C9.77011494,31.8525441 10.3448276,28.9706083 10.3448276,28.4229857 C10.3448276,27.875363 10.6901584,24.6018227 11.38082,18.6023645 C13.6396269,14.8580084 14.7690303,12.9858304 14.7690303,12.9858304 C14.7690303,12.9858304 16.4552156,11.902486 19.8275862,9.73579732 L25,8.62068966 L29.3103448,9.73579732 L33.1686838,11.0089204 L34.6310123,12.9858304 L36.6942114,15.1083711 L38.8004117,19.7846117 L39.6551724,26.6894627 L41.3793103,37.0687931 L34.1720459,38.792931 L36.6942114,41.3793103 L43.1676167,44.0373061 C38.1422062,47.3468719 35.6295009,49.0016549 35.6295009,49.0016549 C35.6295009,49.0016549 24.3906991,50.5901204 24.3906991,50.5901204 C24.3906991,50.5901204 12.5,48.5894164 12.5,48.169151 C12.5,47.8889741 11.2068966,46.2004065 8.62068966,43.1034483 Z",
    id: "Path-7",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2413793,43.1034483 C41.8931034,42.9465517 40.0206897,42.3689655 39.6551724,42.2413793 L37.0689655,41.3793103 C36.3017241,41.112069 35.0982759,40.1844828 34.4827586,39.6551724 L32.7586207,37.9310345",
    id: "Stroke-2326",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75862069,43.1034483 C8.10689655,42.9465517 9.97931034,42.3689655 10.3448276,42.2413793 L12.9310345,41.3793103 C13.6982759,41.112069 14.9017241,40.1844828 15.5172414,39.6551724 L17.2413793,37.9310345",
    id: "Stroke-2327",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3448276,24.137931 C11.8534483,24.137931 13.7931034,25 13.7931034,25 C13.7931034,25 13.9689655,20.6896552 15.5172414,20.6896552 C17.0655172,20.6896552 22.4137931,19.3844828 22.4137931,15.5172414 C22.4137931,17.1913793 27.8827586,20.6896552 34.4827586,20.6896552 C34.4827586,22.3068966 36.2068966,25 36.2068966,25 C36.2068966,25 38.0965517,24.137931 39.6551724,24.137931",
    id: "Stroke-2328",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,8.62068966 C17.2637931,8.62068966 10.3448276,15.8482759 10.3448276,24.137931 C10.3448276,24.8 10.5603448,25.2931034 10.5603448,25.2931034 C10.5603448,25.2931034 10.3448276,27.0741379 10.3448276,27.6017241 C10.3448276,30.1517241 11.3103448,32.2206897 12.5,32.2206897 C12.8517241,32.2206897 13.1793103,32.0224138 13.4724138,31.7017241 C14.9482759,36.35 18.5448276,39.7517241 22.2344828,40.9189655 C22.3965517,40.9741379 22.5603448,41.0275862 22.7241379,41.0724138 C22.9517241,41.1310345 23.1775862,41.1862069 23.4086207,41.2258621 C23.9017241,41.3172414 24.4,41.3793103 24.9103448,41.3793103",
    id: "Stroke-2329",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,8.62068966 C32.7362069,8.62068966 39.6551724,15.8482759 39.6551724,24.137931 C39.6551724,24.8 39.4396552,25.2931034 39.4396552,25.2931034 C39.4396552,25.2931034 39.6551724,27.0741379 39.6551724,27.6017241 C39.6551724,30.1517241 38.6896552,32.2206897 37.5,32.2206897 C37.1482759,32.2206897 36.8206897,32.0224138 36.5275862,31.7017241 C35.0517241,36.35 31.2758621,39.7517241 27.5862069,40.9189655 C27.4241379,40.9741379 27.2603448,41.0275862 27.0948276,41.0724138 C26.8689655,41.1310345 26.6431034,41.1862069 26.412069,41.2258621 C25.9189655,41.3172414 25.4206897,41.3793103 24.9103448,41.3793103",
    id: "Stroke-2330",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.9655172,
    y1: 25.862069,
    x2: 20.6896552,
    y2: 25.862069,
    id: "Stroke-2331",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.3103448,
    y1: 25.862069,
    x2: 31.0344828,
    y2: 25.862069,
    id: "Stroke-2332",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2334",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)",
    points: "39.6551724 27.6015517 41.3793103 37.0687931 33.6206897 38.792931"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2335",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)",
    points: "10.3448276 27.6015517 8.62068966 37.0687931 16.3793103 38.792931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(43.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9238943,0 L17.7002781,4.00450212 L19.7689354,8.30568061 L19.7689354,105.141287 L20.9308792,109.516453 L23.8908567,113.215307 L29.7413793,115 C34.1176464,114.308086 36.3057799,113.713189 36.3057799,113.215307 C36.3057799,112.717426 55.87052,107.879635 95,98.7019333 L94,8.30568061 L92,4.00450212 L89.03221,1.40701139 L85.9466035,0 L12.9238943,0 Z",
    id: "Path-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8275862,15.862069 C6.6091954,16.2959138 0,16.2959138 0,15.862069 C0,15.4282241 0,12.8946968 0,8.26148702 C1.83693061,4.80511785 2.75539592,3.07693326 2.75539592,3.07693326 C2.75539592,3.07693326 4.21295683,2.05128884 7.12807865,0 L12.1716102,0 L16.0030456,1.78240863 L18.8090903,5.68038268 L19.8275862,12.2592691 L19.8275862,15.862069 Z",
    id: "Path-5",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    fill: "#F1F2F4",
    points: "39.6551724 99.137931 39.6551724 105.973517 37.1712791 111.615896 33.0270127 115 58 115 106.914725 115 111.896552 112.637315 115 108.356495 115 99.137931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L83.8395349,0 L84.1162791,0 C89.5760465,0 94,4.55119363 94,10.1679929 L94,46",
    id: "Stroke-741",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 98,
    x2: 95,
    y2: 64,
    id: "Stroke-742",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7413793,115 L104.998966,115 L105.086207,115 C110.562586,115 115,110.562586 115,105.086207 L115,99.137931 L39.6551724,99.137931 L39.6551724,105.086207 C39.6551724,110.562586 35.2177586,115 29.7413793,115 C24.265,115 19.8275862,110.562586 19.8275862,105.086207 L19.8275862,10.0010345 C19.8275862,4.47706897 15.4377586,0 9.9137931,0 L9.95741379,0 C4.43344828,0 0,4.47706897 0,10.0010345 L0,15.862069 L19.8275862,15.862069",
    id: "Stroke-743",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 21,
    x2: 68,
    y2: 21,
    id: "Stroke-746",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 37,
    x2: 79,
    y2: 37,
    id: "Stroke-747",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 51,
    x2: 72,
    y2: 51,
    id: "Stroke-748",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 64,
    x2: 64,
    y2: 64,
    id: "Stroke-749",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.889834,47.3346406 L84.3367118,75.8877627 L69,81 L74.1122373,65.6673424 L102.665359,37.1101661 C105.482968,34.2966113 110.043846,34.2966113 112.857401,37.1101661 L112.889834,37.142599 C115.703389,39.9561539 115.703389,44.5210858 112.889834,47.3346406 Z",
    id: "Stroke-744",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-744",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "84.3367118 75.8877627 69 81 74.1122373 65.6673424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-744",
    fill: "#17243D",
    points: "76 78.6660497 69 81 71.3333333 74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(81.723228, 40.500000)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 24.7462841,
    x2: 24.7462841,
    y2: 0,
    id: "Path-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 27.7462841,
    x2: 27.7462841,
    y2: 3,
    id: "Path-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(128.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-2600",
    fill: "#25D086",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4827586,34.4827586 L27.2413793,31.5844727 L28.9655172,26.2068966 L32.8835449,24.1308594 L34.4827586,21.125 L32.1960449,15.1724138 L33.4223633,14.1262207 L30.3448276,8.85302734 L24.8275862,5.51724138 L20.6896552,6.04345703 L17.947998,5.51724138 L14.4827586,6.04345703 L10.1418457,8.85302734 L6.66650391,12.7763672 L6.66650391,14.7670898 L8.27586207,15.1724138 L6.20689655,18.6206897 L5.51724138,21.125 L7.45361328,24.4814453 L9.65517241,25.5172414 L11.5749512,27.5862069 C13.5134895,29.8850575 14.2528736,31.0344828 13.7931034,31.0344828 C13.3333333,31.0344828 11.6057494,31.9722073 8.61035156,33.8476562 L5.51724138,35.0144043 L10.4985352,39.0061035 L16.5517241,40.5561523 L21.0427246,40.9914551 L26.2068966,40 L30.3448276,38 L34.1623535,36.0541992 L34.4827586,34.4827586 Z",
    id: "Path-4",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7931034,34.4827586 C33.5144828,34.3572414 32.0165517,33.8951724 31.7241379,33.7931034 L29.6551724,33.1034483 C29.0413793,32.8896552 28.0786207,32.1475862 27.5862069,31.7241379 L26.8965517,31.0344828",
    id: "Stroke-2596",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20689655,34.4827586 C6.48551724,34.3572414 7.98344828,33.8951724 8.27586207,33.7931034 L10.3448276,33.1034483 C10.9586207,32.8896552 11.9213793,32.1475862 12.4137931,31.7241379 L13.1034483,31.0344828",
    id: "Stroke-2597",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.1724138,
    y1: 20.6896552,
    x2: 16.5517241,
    y2: 20.6896552,
    id: "Stroke-2598",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4482759,
    y1: 20.6896552,
    x2: 24.8275862,
    y2: 20.6896552,
    id: "Stroke-2599",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65517241,19.3103448 L9.65517241,19.3103448 C8.70344828,19.3103448 8.27586207,20.8537931 8.27586207,22.7586207 C8.27586207,24.6634483 9.39310345,26.2068966 10.3448276,26.2068966 L11.0344828,26.2068966 C12.2137931,29.6786207 14.9793103,31.8882759 17.9310345,32.76 C18.0606897,32.8013793 18.1917241,32.8413793 18.3241379,32.8744828 C18.5048276,32.9172414 18.6855172,32.9586207 18.8703448,32.9889655 C19.2648276,33.0565517 19.5917241,33.1034483 20,33.1034483 C20.4082759,33.1034483 20.8786207,33.0565517 21.2731034,32.9889655 C21.457931,32.9586207 21.6386207,32.9172414 21.8193103,32.8744828 C21.9517241,32.8413793 22.0827586,32.8013793 22.2124138,32.76 C25.1641379,31.8882759 27.7862069,29.6786207 28.9655172,26.2068966 C29.2,26.4468966 29.3737931,26.2068966 29.6551724,26.2068966 C30.6068966,26.2068966 31.7241379,24.6634483 31.7241379,22.7586207 C31.7241379,20.8537931 31.2965517,19.3103448 30.3448276,19.3103448",
    id: "Stroke-2601",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9655172,26.2068966 L28.9655172,24.8275862 C27.262069,25.68 26.6055172,26.2068966 24.8275862,26.2068966 C23.0496552,26.2068966 21.9393103,24.8275862 20,24.8275862 C18.0606897,24.8275862 16.9503448,26.2068966 15.1724138,26.2068966 C13.3944828,26.2068966 12.737931,25.72 11.0344828,24.8275862 L11.0344828,26.2068966",
    id: "Stroke-2602",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.3103448,
    y1: 27.5862069,
    x2: 20.6896552,
    y2: 27.5862069,
    id: "Stroke-2603",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3448276,19.3103448 L30.3131034,19.3103448 C29.9806897,12.7089655 25.0206897,8.27586207 20,8.27586207 C14.9793103,8.27586207 9.9862069,12.7089655 9.65517241,19.3103448",
    id: "Stroke-2604",
    stroke: "#17243D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.20689655 C20,6.20689655 19.0303448,5.51724138 16.5517241,5.51724138 C14.0731034,5.51724138 8.29793103,8.96551724 6.89655172,12.4137931 C5.49517241,15.862069 8.27586207,15.1724138 8.27586207,15.1724138 C8.27586207,15.1724138 5.51724138,17.9958621 5.51724138,20.6896552 C5.51724138,23.3834483 8.27586207,24.8275862 8.27586207,24.8275862",
    id: "Stroke-2605",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.20689655 C20,6.20689655 20.9696552,5.51724138 23.4482759,5.51724138 C25.9268966,5.51724138 31.702069,8.96551724 33.1034483,12.4137931 C34.5048276,15.862069 31.7241379,15.1724138 31.7241379,15.1724138 C31.7241379,15.1724138 34.4827586,17.9958621 34.4827586,20.6896552 C34.4827586,23.3834483 31.7241379,24.8275862 31.7241379,24.8275862",
    id: "Stroke-2606",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8275862,17.9310345 C24.8275862,17.9310345 25.5172414,17.9310345 26.2068966,18.6206897",
    id: "Stroke-2607",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1724138,17.9310345 C15.1724138,17.9310345 14.4827586,17.9310345 13.7931034,18.6206897",
    id: "Stroke-2608",
    stroke: "#17243D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 124,
    cy: 222,
    rx: 50,
    ry: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoauthorStories);
export default __webpack_public_path__ + "static/media/coauthor-stories.9ecd028faa02b5b8ceb579fe4d8badc3.svg";
export { ForwardRef as ReactComponent };